module.exports = __webpack_public_path__ + "img/logo-Krungsri.d1d7b46.png";